export var TextDelta;
(function (TextDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["TEXT_DELTA"] = "text_delta";
    })(type = TextDelta.type || (TextDelta.type = {}));
})(TextDelta || (TextDelta = {}));
